/** The bundle worker started from its bundle under the app's Trusted Types policy (part 24a; part 15, table T). */
import type { WorkerSource } from '../preview/platform.ts';
import type { BundleWorker } from './controller.ts';

/** T6, T7: a function starting a bundle worker (a module worker) for each bundle. */
export function bundleWorker(source: WorkerSource<BundleWorker>): (store: string) => BundleWorker {
  // Part 36a, table BK10: named by the book store it reads, which the worker opens by that name.
  return (store) => new source.Worker(source.trusted(source.url), { type: 'module', name: store });
}
